module.exports = ".mason .actions .t_l3{\r\n\tfont-size: 14px;\r\n}\r\n.mason .actions > li{\r\n\tpadding-top: 10px;\r\n\tpadding-bottom: 10px;\r\n}"